import { io, type Socket } from 'socket.io-client';
import { useAuthStore } from '@/stores/auth.store';

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (socket && socket.connected) return socket;

  const { token } = useAuthStore.getState();
  // El gateway de chat vive en el namespace /chat (igual que el widget).
  // Usamos location.origin (VITE_WS_URL viene como "/" y romperia el host -> //chat).
  const url = `${window.location.origin}/chat`;

  socket = io(url, {
    path: '/socket.io',
    transports: ['websocket'],
    auth: { token },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  socket.on('connect', () => {
    // eslint-disable-next-line no-console
    console.info('[socket] connected', socket?.id);
  });

  socket.on('disconnect', (reason) => {
    // eslint-disable-next-line no-console
    console.info('[socket] disconnected:', reason);
  });

  socket.on('connect_error', (err) => {
    // eslint-disable-next-line no-console
    console.warn('[socket] connect_error:', err.message);
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
}
